<template>
  <div class="tab-nav">
    <span
      class="tab-nav__label"
      v-for="(p, index) in panes"
      :key="index"
      :style="{margin: '0 '+ plr * ratio + 'px'}"
      :class="(currentName == p.props.name?'active':'') + ' '+ (p.props.disabled ? 'disabled':'')"
      @click="changeCurrentName(p)"
    >
      {{p.props.label}}
      <span class="tab-nav__active-line"></span>
      <sub
        class="tab-nav__superscript"
        v-if="p.props.superscript >= 0 && !p.props['superscript-bg-color']"
      >{{p.props.superscript}}</sub>
      <sub
        class="tab-nav__superscript has-color"
        :style="{'font-size': p.props['superscript-size'], background: p.props['superscript-bg-color'], color: p.props['superscript-color']}"
        v-if="p.props['superscript-bg-color']"
      >{{p.props.superscript}}</sub>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    panes: {
      type: Array,
      default: () => [],
    },
    currentName: {
      type: [String, Number],
      default: '',
    },
    inactiveColor: {
      type: String,
      default: '#aaa',
    },
    activeColor: {
      type: String,
      default: '#333',
    },
    activeLineColor: {
      type: String,
      default: '#ff5500',
    },
    plr: {
      type: [Number, String],
      default: 40,
    },
  },
  inject: ['rootTabs'],
  methods: {
    changeCurrentName(v) {
      if (v.props.disabled || this.currentName == v.props.name) {
        return
      }
      this.rootTabs.change(v.props.name)
    },
  },
}
</script>

<style lang="less" scoped>
.tab-nav {
  font-size: 0;
  border-bottom: 1px solid #e9e9e9;
  margin: 0 -8px;
}
.tab-nav__label {
  display: inline-block;
  line-height: 80px;
  font-size: 30px;
  font-weight: 500;
  color: v-bind(inactiveColor);
  position: relative;
  &.disabled {
    background: #f1f1f1;
  }
}
.tab-nav__active-line {
  width: 0px;
  height: 6px;
  background: v-bind(activeLineColor);
  border-radius: 3px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  opacity: 0;
  transition: width 0.3s;
}
.tab-nav__superscript {
  line-height: 20px;
  font-size: 20px;
  font-weight: 500;
  color: #aaaaaa;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  left: calc(100% + 5px);
  &.has-color {
    width: 68px;
    line-height: 32px;
    border-radius: 16px;
    font-size: 22px;
    text-align: center;
    top: 30%;
    left: calc(100% + 5px);
  }
}
.active {
  color: v-bind(activeColor);
  .tab-nav__active-line {
    width: 40px;
    opacity: 1;
  }
}
</style>